// components/SessionMonitor.js
import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

const SessionMonitor = () => {
    const { isTokenExpiring, extendSession, logout, getSessionTimeLeft } = useAuth();
    const [showWarning, setShowWarning] = useState(false);

    useEffect(() => {
        const checkSession = setInterval(() => {
            if (isTokenExpiring(10)) { // Advertir 10 minutos antes
                setShowWarning(true);
            }
        }, 60000); // Revisar cada minuto

        return () => clearInterval(checkSession);
    }, [isTokenExpiring]);

    // ✅ Auto-extender sesión con actividad del usuario
    useEffect(() => {
        const handleActivity = () => {
            if (isTokenExpiring(30)) { // Si quedan menos de 30 minutos
                extendSession(24); // Extender 24 horas más
                console.log('🔄 Sesión extendida automáticamente por actividad');
            }
        };

        const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];

        events.forEach(event => {
            document.addEventListener(event, handleActivity, true);
        });

        return () => {
            events.forEach(event => {
                document.removeEventListener(event, handleActivity, true);
            });
        };
    }, [extendSession, isTokenExpiring]);

    const handleExtend = () => {
        extendSession(24);
        setShowWarning(false);
    };

    const formatTimeLeft = () => {
        const timeLeft = getSessionTimeLeft();
        const minutes = Math.floor(timeLeft / (1000 * 60));
        return `${minutes} minutos`;
    };

    if (!showWarning) return null;

    return (
        <div className="session-warning-overlay">
            <div className="session-warning-modal">
                <h3>⚠️ Sesión por expirar</h3>
                <p>Tu sesión expirará en {formatTimeLeft()}. ¿Deseas extenderla?</p>
                <div className="session-warning-buttons">
                    <button onClick={handleExtend} className="btn-primary">
                        Extender sesión
                    </button>
                    <button onClick={logout} className="btn-secondary">
                        Cerrar sesión
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SessionMonitor;